<template>
    <div class="date">
        <v-dialog
                v-model="dialogModel"
                width="290"
                @click:outside="cancel()"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                        :value="getTitle"
                        :label="$t(label)"
                        readonly
                        :clearable="clearable"
                        v-on="on"
                        outlined
                        :dense="!isMobile"
                        hide-details="auto"
                        :class="className"
                        :style="inputStyle"
                        @click:clear="clear()"
                ></v-text-field>
            </template>
            <v-card class="date__wrap">
                <v-date-picker
                        v-model="pickerValue"
                        scrollable
                        :locale="$store.getters.lang"
                        :first-day-of-week="1"
                ></v-date-picker>
                <div class="pa-3">
                    <btns-wrap>
                        <c-btn
                            color="primary"
                            @click="cancel()"
                        >{{ $t('msg.cancel') }}</c-btn>
                        <c-btn
                            color="primary"
                            @click="apply()"
                        >{{ $t('msg.apply') }}</c-btn>
                    </btns-wrap>
                </div>
            </v-card>
        </v-dialog>
        <div
                v-if="errorMessages.length > 0"
                class="date__error"
        >{{ errorMessages[0] }}</div>
    </div>
</template>

<script>
export default {
    props: {
        value: String,
        label: {type: String, default: 'msg.date'},
        clearable: {type: Boolean, default: false},
        className: {type: String},
        width: {type: Number, default: 180},
        errorMessages: {type: Array}
    },
    data() {
        return {
            localValue: this.value,
            pickerValue: this.value,
            dialogModel: false
        }
    },
    computed: {
        inputStyle() {
            let style = {};
            if (this.width !== undefined && this.width !== 0) {
                style.width = this.width+'px';
            }
            return style;
        },
      getTitle() {
          return this.dateString(this.localValue);
      }
    },
    watch: {
        value(v) {
            this.localValue = v;
            this.pickerValue = v;
        }
    },
    methods: {
        clear() {
            this.pickerValue = null;
            this.apply();
        },
        apply() {
            this.localValue = this.pickerValue;
            this.$emit('input', this.localValue);
            this.dialogModel = false;
        },
        cancel() {
            this.pickerValue = this.localValue;
            this.dialogModel = false;
        }
    }
}
</script>

<style lang="scss">
    .date {}
    .date__error {
        color: #ff5252;
        padding: 2px 0 0 10px;
    }
    .date__wrap {
        .v-picker {
            box-shadow: none !important;
        }
        .v-date-picker-table {
            height: inherit !important;
        }
    }
</style>